import { render, staticRenderFns } from "./TemplateCertificates.vue?vue&type=template&id=8a99a5f6&scoped=true&"
import script from "./TemplateCertificates.vue?vue&type=script&lang=js&"
export * from "./TemplateCertificates.vue?vue&type=script&lang=js&"
import style0 from "./TemplateCertificates.vue?vue&type=style&index=0&id=8a99a5f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a99a5f6",
  null
  
)

export default component.exports